import React, { useRef } from "react";
import { motion } from "framer-motion";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import AboutSection from "./components/AboutSection";
import TestimonialsSection from "./components/TestimonialSection";
import AchievementSection from "./components/AchievementSection";
import ContactSection from "./components/ContactSection";
import MapComponent from "./components/MapSection";
import Brand1 from "./components/Tools";
import Footer from "./components/Footer";
import WhatWeDo from "./components/work";
import WhatsAppButton from "./components/whatsapp";
import WorkflowSection from "./components/workflow";
import Timeline from "./components/timeline";
import ThesisTimeline from "./components/thesis";

import "./App.css";

// Reusable motion wrapper for sections
const ScrollSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

const App = () => {
  const servicesRef = useRef(null);
  const whatWeDoRef = useRef(null);
  const contact = useRef(null);
  const ach = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="App">
        <Header
          scrollToSection={scrollToSection}
          servicesRef={servicesRef}
          whatWeDoRef={whatWeDoRef}
          contact={contact}
          ach={ach}
        />

        
        <HeroSection />       
        <WhatWeDo ref={whatWeDoRef} />       
        <WorkflowSection />       
        {/* <ScrollSection> */}
        <ServicesSection ref={servicesRef} />
        {/* </ScrollSection> */}
        {/* <ThesisTimeline /> */}       
        <Brand1 />       
        <AboutSection />       
        <AchievementSection ref={ach} />       
        <TestimonialsSection />      
        <ContactSection ref={contact} />
        <Footer
          scrollToSection={scrollToSection}
          servicesRef={servicesRef}
          whatWeDoRef={whatWeDoRef}
          contact={contact}
          ach={ach}
        />
      </div>

      <WhatsAppButton />
    </>
  );
};

export default App;
